<template>
	<v-card elevation="0" :key="renderizar" color="background">
		<v-card-title class="pb-0 pt-0 texto--text"><strong>Filtar por:</strong></v-card-title>
		<v-list class="pt-0" expand :width="largura" color="background">
			<template v-for="(filtro, i) in filtros">
				<v-list-group :key="i" v-if="filtro.nome" :value="true" color="texto">
					<template slot="activator">
						<v-list-item-content>
							<v-list-item-title class="filtrosTitulo">
								<strong>{{ filtro.nome }}</strong>
							</v-list-item-title>
						</v-list-item-content>
					</template>
					<template v-for="(item, j) in filtro.itens">
						<v-list-item :key="j" v-if="j < limites[i]">
							<v-list-item-action>
								<v-checkbox
									class="checkbox"
									v-model="filtrosSelecionados[i]"
									:value="item.nome"
									:label="item.nome"
									:multiple="false"
									@click="filtrar(i, filtrosSelecionados[i])"
								/>
							</v-list-item-action>
						</v-list-item>
					</template>
					<v-btn color="primary" text @click="mostrar(i)" v-if="filtro.itens && filtro.itens.length > 3">
						{{ limites[i] == filtro.itens.length ? 'mostrar menos' : 'mostrar mais' }}
					</v-btn>
				</v-list-group>
			</template>
		</v-list>
		<v-card-actions class="pb-5" v-if="mobile">
			<v-spacer />
			<v-btn color="primary" text @click="limparFiltroMobile">limpar</v-btn>
			<v-spacer />
			<v-btn color="primary" @click="filtrarMobile">filtrar</v-btn>
			<v-spacer />
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	props: {
		marcas: {},
		grupos: {},
		subgrupos: {},
		mobile: Boolean,
	},
	data() {
		return {
			filtrosSelecionados: [],
			limites: [3, 3, 3],
			expandir: [true, true, true],
			renderizar: false,
		}
	},
	computed: {
		filtros() {
			let filtros = []
			filtros.push(this.marcas)
			filtros.push(this.grupos)
			filtros.push(this.subgrupos)

			return filtros
		},
		largura(){
			if(this.mobile) return '100%'
			else return '180'
		}
	},
	methods: {
		filtrar(filtro, nome) {
			if (!this.mobile) {
				if (filtro == 0) {
					this.filtrarMarca(nome)
				} else if (filtro == 1) {
					this.filtrarGrupo(nome)
				} else if (filtro == 2) {
					this.filtrarSubgrupo(nome)
				}
			}
		},
		filtrarMobile() {
			if (this.mobile) {
				this.$router.replace(
					{
						query: Object.assign(
							{ ...this.$route.query },
							{
								marca: this.filtrosSelecionados[0] ? this.filtrosSelecionados[0] : '',
								grupo: this.filtrosSelecionados[1] ? this.filtrosSelecionados[1] : '',
								subgrupo: this.filtrosSelecionados[2] ? this.filtrosSelecionados[2] : '',
								pagina: 1,
							}
						),
					},
					() => {}
				)
			}
		},
		limparFiltroMobile() {
			this.filtrosSelecionados = []
			this.filtrarMobile()
		},
		filtrarMarca(nome) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							marca: nome,
							pagina: 1,
						}
					),
				},
				() => {}
			)
		},
		filtrarGrupo(nome) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							grupo: nome,
							pagina: 1,
						}
					),
				},
				() => {}
			)
		},
		filtrarSubgrupo(nome) {
			this.$router.replace(
				{
					query: Object.assign(
						{ ...this.$route.query },
						{
							subgrupo: nome,
							pagina: 1,
						}
					),
				},
				() => {}
			)
		},
		mostrar(i) {
			this.limites[i] = this.limites[i] == this.filtros[i].itens.length ? 3 : this.filtros[i].itens.length

			this.renderizar = !this.renderizar
		},
	},
	beforeMount() {
		this.filtrosSelecionados[0] = this.$route.query.marca ? this.$route.query.marca : ''
		this.filtrosSelecionados[1] = this.$route.query.grupo ? this.$route.query.grupo : ''
		this.filtrosSelecionados[2] = this.$route.query.subgrupo ? this.$route.query.subgrupo : ''
	},
}
</script>

<style>
.filtrosTitulo {
	font-size: 1.2rem;
}

.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    min-width: 0px; 
}

.v-label.theme--light{
	color: var(--v-texto-base);
}

.checkbox .theme--light.v-icon {
    color: var(--v-texto-base);
}


</style>
